import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = `https://api.dilanaslan.com/api/testimonials`;

// Tüm yorumları çek
export const fetchTestimonials = createAsyncThunk(
  "testimonials/fetchTestimonials",
  async () => {
    const res = await axios.get(BASE_URL);
    return res.data;
  }
);

// Yorum ID'ye göre getir
export const fetchTestimonialById = createAsyncThunk(
  "testimonials/fetchById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/${id}`);
    return res.data;
  }
);

// Yeni yorum oluştur
export const createTestimonial = createAsyncThunk(
  "testimonials/createTestimonial",
  async (newTestimonial) => {
    const res = await axios.post(BASE_URL, newTestimonial);
    return res.data;
  }
);

// Yorum güncelle
export const updateTestimonial = createAsyncThunk(
  "testimonials/updateTestimonial",
  async ({ id, updatedTestimonial }) => {
    const res = await axios.put(`${BASE_URL}/${id}`, updatedTestimonial);
    return res.data;
  }
);

// Yorum sil
export const deleteTestimonial = createAsyncThunk(
  "testimonials/deleteTestimonial",
  async (id) => {
    await axios.delete(`${BASE_URL}/${id}`);
    return id;
  }
);

const testimonialsSlice = createSlice({
  name: "testimonials",
  initialState: {
    testimonials: [],
    selectedTestimonial: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedTestimonial: (state) => {
      state.selectedTestimonial = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload.testimonials || [];
      })
      .addCase(fetchTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch by ID
      .addCase(fetchTestimonialById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestimonialById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTestimonial = action.payload;
      })
      .addCase(fetchTestimonialById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials.unshift(action.payload);
      })
      .addCase(createTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Update
      .addCase(updateTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.testimonials.findIndex(
          (item) => item._id === action.payload._id
        );
        if (index !== -1) {
          state.testimonials[index] = action.payload;
        }
        if (
          state.selectedTestimonial &&
          state.selectedTestimonial._id === action.payload._id
        ) {
          state.selectedTestimonial = action.payload;
        }
      })
      .addCase(updateTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Delete
      .addCase(deleteTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = state.testimonials.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearSelectedTestimonial } = testimonialsSlice.actions;
export default testimonialsSlice.reducer;
